import { MARKET_URL_KEY } from "../constants";
import type { MarketUrlKey, RedirectSource } from "../types";

export const REDIRECT_SOURCES: RedirectSource[] = [
  { id: "battery", subdomain: "battery", urlKey: "BatteryUrl" },
  { id: "device", subdomain: "devices", urlKey: "DeviceRegistrationUrl" },
];
export const resolveRedirectSource = (source: string | null): RedirectSource | null => {
  const hostname = typeof window === "undefined" ? "" : window.location.hostname;
  return REDIRECT_SOURCES.find(({ id, subdomain }) => source === id || hostname.startsWith(`${subdomain}.`)) ?? null;
};

export const getMarketUrlKey = (redirectSource: RedirectSource | null): MarketUrlKey =>
  redirectSource?.urlKey ?? MARKET_URL_KEY;

export const appendQueryString = (url: string, queryString: string): string => {
  const params = queryString.startsWith("?") ? queryString.slice(1) : queryString;
  if (!params) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${params}`;
};
